import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Stage } from '../../models/projects/operation.models';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class StageService {
  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
  ) {
  }

  getSummaries(ids: number[]): Promise<Stage[]> {
    const url = `${this.config.apiUrl}api/stage/summary`;
    return this.http
      .post<Stage[]>(url, ids)
      .toPromise()
      .then((res: Stage[]) => {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/stage/stage.service.ts